<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormQuery
				v-if="query"
				align="center"
				:formdata="getBase"
				:value="formData"
				class="margin-layout"
			></compFormQuery>
			<compFormEdit
				v-else
				ref="baseform"
				align="center"
				class="margin-layout"
				:formdata="getBase"
				v-model="formData"
			/>
		</compWrapper>
		<compLog v-if="query" wrapper :data="opLogList" :columns="getLogcolumns"></compLog>
		<vButtonGroup class="text-right">
			<vButton v-if="!query" class="width-15per" theme="primary" @click="submit">{{$t('global.common.update_submit',{defaultValue:'提交'})}}</vButton>
			<vButton class="width-15per" @click="cancel">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
		</vButtonGroup>
		<vLoading size="large" fix v-if="loading"></vLoading>
	</div>
</template>
<script>

import { HttpMinCost, HttpSaveMinCost, HttpGetLog } from "@/service/fedex";
import { mapGetters } from "vuex";
import mixin from '../mixin';

export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			query: false,
			opLogList: [],
			formData: {}
		}
	},
	created() {
		this.query = this.type === "query";
		this.getDetail()
	},
	computed: {
		...mapGetters('dictionary', ['getCarrierServiceAllList']),
		getBase() {
			let query = this.type == 'edit' || this.type == 'query'
			return [
				{
					label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
					key: "account",
					query,
				},
				{
					// label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
                    label: "承运商服务",
					key: "carrierServiceCode",
					tag:'vSelect',
					options: this.getCarrierServiceAllList.map(item=>{
						return {
							value:item.attach.carrierServiceCode,
							label:item.attach.carrierServiceCode,
						}
					}),
					query,
					props:{
						filterable:true,
					}
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_min',{defaultValue:'重量区间最小值'}),
					key: "weightRangeMin",
					tag: 'vInput',
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">lbs</span>
					},
					show:this.type!='query'
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_min',{defaultValue:'重量区间最小值'}),
					valueText:`${this.formData.weightRangeMin} lbs`,
					show:this.type=='query'
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'}),
					tag: 'vInput',
					key: "weightRangeMax",
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">lbs</span>
					},
					show:this.type!='query'
				},
				{
					label: this.$t('fbb.account.cusdisacountrate_weight_max',{defaultValue:'重量区间最大值'}),
					valueText:`${this.formData.weightRangeMax} lbs`,
					show:this.type=='query'
				},
				{
					label: this.$t('fbb.customerMinimumCharges.minCost',{defaultValue:'最低收费'}),
					tag: 'vInput',
					key: "minCost",
					children(h) {
						return <span slot='append' class="padding-left-10 padding-right-10">USD</span>
					},
					show:this.type!='query'
				},
				{
					label: this.$t('fbb.customerMinimumCharges.minCost',{defaultValue:'最低收费'}),
					valueText:`${this.formData.minCost} USD`,
					show:this.type=='query'
				},
			];
		},
	},
	methods: {
		async getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpMinCost({
				id: this.id
			}).then(res => {
				this.loading = false;
				this.handleResponse(res.data);
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});

			if(this.query){
				// 请求日志的接口
				HttpGetLog({
					id:this.id,
					module:26,
				}).then(res=>{
					this.opLogList = res.data
				},err=>{

				})
			}
		},
		handleResponse(data={}){
			this.formData = data
		},
		async submit() {
			const valid = await this.$refs['baseform'].validate();
			if (!valid) return;

			let oneitem;
			this.getCarrierServiceAllList.forEach(item => {
				if(this.formData.carrierServiceCode == item.attach.carrierServiceCode){
					oneitem = item
				}
			});
			this.formData.carrierCode = oneitem.attach.carrierCode

			this.loading = true
			HttpSaveMinCost(this.formData).then(res => {
				this.cancel();
				this.$VMessage.success(res.message);
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		cancel() {
			this.$router.push({ name: "fedexMincharge" })
		}
	},
}
</script>
